export const SCENE_EVENTS = {
  SCENE_DATA_RECIEVED: "SCENE_DATA_RECIEVED",
  SCENE_DATA_ERROR: "SCENE_DATA_ERROR",
  SCENE_SAVED_STARTED: "SCENE_SAVED_STARTED",
  SCENE_SAVED_SUCCESS: "SCENE_SAVED_SUCCESS",
  SCENE_SAVED_ERROR: "SCENE_SAVED_ERROR",
  SCENE_CHANGED: "SCENE_CHANGED",
  START_SCENE_CHANGE: "START_SCENE_CHANGE",
  STOP_SCENE_CHANGE: "STOP_SCENE_CHANGE",
  SCENE_CHANGED_ANIMATION_ENDED: "SCENE_CHANGED_ANIMATION_ENDED",
  SCENE_EDIT_DATA_CHANGED: "SCENE_EDIT_DATA_CHANGED",
  SPACE_TYPE_CHANGED: "SPACE_TYPE_CHANGED",

  SOMEONE_JOINED_ROOM: "SOMEONE_JOINED_ROOM",
  SOMEONE_LEAVED_ROOM: "SOMEONE_LEAVED_ROOM",
  SOMEONE_CHANGED_DATA: "SOMEONE_CHANGED_DATA",
  SOMEONE_SPOKE: "SOMEONE_SPOKE",

  ONE_ON_ONE_CHAT: "ONE_ON_ONE_CHAT",
  CREATE_OFFLINE_CHAT: "CREATE_OFFLINE_CHAT",
  USER_JOIN_ROOM_INVITATAION: "USER_JOIN_ROOM_INVITATAION",
  GLOBAL_USER_JOIN_WORLD_INVITATAION: "GLOBAL_USER_JOIN_WORLD_INVITATAION",
  GLOBAL_USER_JOIN_WORLD_GLOBAL_INVITATAION:
    "GLOBAL_USER_JOIN_WORLD_GLOBAL_INVITATAION",
  GLOBAL_USER_JOIN_TOUR: "GLOBAL_USER_JOIN_TOUR",

  ENVIRONMENT_CHANGED: "ENVIRONMENT_CHANGED",
  TINY_WORLD_ANIMATION_ENDED: "TINY_WORLD_ANIMATION_ENDED",
  START_TINY_ANIMATION_OUTRO: "START_TINY_ANIMATION_START",
  END_TINIY_ANIMATION_OUTRO: "END_TINIY_ANIMATION_OUTRO",
  START_ANIMTAION_OUTRO: "START_ANIMTAION_OUTRO",

  ON_FRIENDS_SET: "ON_FRIENDS_SET",

  GRID_MODE: "GRID_MODE",
  CLOSE_SCREEN_SHARE_MENU: "CLOSE_SCREEN_SHARE_MENU",

  GUIDED_MODE_START: "GUIDED_MODE_START",
  GUIDED_MODE_STOP: "GUIDED_MODE_STOP",

  GUIDE_MODE_OFF: "GUIDE_MODE_OFF",
  TOUR_MODE_ENDED: "TOUR_MODE_ENDED",
  TOUR_MODE_STARTED: "TOUR_MODE_STARTED",
  ON_TOUR_INVITATION: "ON_TOUR_INVITATION",
  ON_TOUR_GUEST_INVITATION: "ON_TOUR_GUEST_INVITATION",
  ON_TOUR_CONTRIBUTORE_ACCEPTED: "ON_TOUR_CONTRIBUTORE_ACCEPTED",
  ON_TOUR_GUEST_ACCEPTED: "ON_TOUR_GUEST_ACCEPTED",

  ///NEW
  TOUR_CONTRIBUTE_ADDED: "TOUR_CONTRIBUTE_ADDED",
  TOUR_CONTRIBUTE_REMOVED: "TOUR_CONTRIBUTE_REMOVED",
  TOUR_NEW_USER: "TOUR_NEW_USER",
  TOUR_MODE_WINDOW_OPENED: "TOUR_MODE_WINDOW_OPENED",
  TOUR_MODE_WINDOW_CLOSED: "TOUR_MODE_WINDOW_CLOSED",
  TOUR_CONTROLLER_INITIALIZED: "TOUR_CONTROLLER_INITIALIZED",
  TOUR_ROOM_JOINED: "TOUR_ROOM_JOINED",
  TOUR_ROOM_LEFT: "TOUR_ROOM_LEFT",
  TOUR_PUBLISH_STARTED: "TOUR_PUBLISH_STARTED",

  // Setting Menu
  OPEN_SETTING_MENU: "OPEN_SETTING_MENU",
  OPEN_MEDIA_SETTINGS: "OPEN_MEDIA_SETTINGS",
  DEVICE_SETTINGS_CHANGED: "DEVICE_SETTINGS_CHANGED",

  FOLDABLE_DIALOG_OPENED: "FOLDABLE_DIALOG_OPENED",
  FOLDABLE_DIALOG_CLOSED: "FOLDABLE_DIALOG_CLOSED",
  FOLDABLE_DIALOG_BACK: "FOLDABLE_DIALOG_BACK",

  UPDATE_TOUR_UI_ON_SOCKET_DATA: "UPDATE_TOUR_UI_ON_SOCKET_DATA",
  HIDE_CAMERA_COMPONENTS_CONTEXT_MENU: "HIDE_CAMERA_COMPONENTS_CONTEXT_MENU",

  USER_INVERTS_CAMERA: "USER_INVERTS_CAMERA",
  USER_SEAT_TURN_CAMERA_ON: "USER_SEAT_TURN_CAMERA_ON",
  USER_SEAT_TURN_CAMERA_OFF: "USER_SEAT_TURN_CAMERA_OFF",
  USER_SEAT_TURN_MIC_OFF: "USER_SEAT_TURN_MIC_OFF",
  USER_SEAT_TURN_MIC_ON: "USER_SEAT_TURN_MIC_ON",
  USER_SCREEN_SHARE_TURN_MIC_OFF: "USER_SCREEN_SHARE_TURN_MIC_OFF",
  USER_SCREEN_SHARE_TURN_MIC_ON: "USER_SCREEN_SHARE_TURN_MIC_ON",

  CUSTOM_TAKE_SEAT: "CUSTOM_TAKE_SEAT",
  USER_INIT_MODAL_CLOSE: "USER_INIT_MODAL_CLOSE",
  MODAL_DEACTIVATE_USER: "MODAL_DEACTIVATE_USER",

  //UI
  LAYOUT_MODE_CHANGED: "LAYOUT_MODE_CHANGED",
  NAVBAR_ITEM_CLICKED: "NAVBAR_ITEM_CLICKED",
  SHOW_OWN_CHAIR_MENU: "SHOW_OWN_CHAIR_MENU",
  OPEN_CHESS_MODAL: "OPEN_CHESS_MODAL",
  SHOW_CHESS_MENU: "SHOW_CHESS_MENU",
  HIDE_CHESS_MENU: "HIDE_CHESS_MENU",
  SHOW_CHESS_PLAYER_MODE_MENU: "SHOW_CHESS_PLAYER_MODE_MENU",
  SHOW_CHESS_SPECTATOR_MODE_MENU: "SHOW_CHESS_SPECTATOR_MODE_MENU",
  CREATE_CHESS_CHAT: "CREATE_CHESS_CHAT",
  REMOVE_CHESS_CHAT: "REMOVE_CHESS_CHAT",
  SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU: "SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU",
  HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU: "HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU",
  SHOW_CLOSE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU: "SHOW_CLOSE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU",
  HIDE_CLOSE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU: "HIDE_CLOSE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU",
  GAMING_DATA_PROCESSED: 'GAMING_DATA_PROCESSED',
  FORCE_QUIT_CHESS_GAME: "FORCE_QUIT_CHESS_GAME",

  PROFILE_MENU_OPEN: "PROFILE_MENU_OPEN",
  PROFILE_MENU_CLOSE: "PROFILE_MENU_CLOSE",

  LANGUAGE_MENU_OPEN: "LANGUAGE_MENU_OPEN",
  LANGUAGE_MENU_CLOSE: "LANGUAGE_MENU_CLOSE",

  //postits
  RELOAD_POSTITS: "RELOAD_POSTITS",
};

export const MODEL_EVENTS = {
  SOCKET_READY: "SOCKET_READY",
};

export const TRACKING_EVENT_TYPES = {
  WORLD: "world",
  SCENE: "scene",
  GUEST_SEAT: "guestSeat",
};

export const TRACKING_EVENT_ACTIONS = {
  START_WORLD: "startWorld",
  CHANGE_SCENE: "changeScene",
  TAKE_A_SEAT: "takeASeat",
  START_TOUR: "startTour",
  JOIN_TOUR: "joinTour",
  END_TOUR: "endTour",
};
